<template>
  <b-card   >

    <div v-if="loading" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>

    <b-form @submit.prevent="createDevice" class="repeater-form" style="overflow: visible;">
      <b-row>
        <b-col>
          <b-tabs vertical content-class="col-12 col-md-9 mt-1 mt-md-0" pills
        nav-wrapper-class="col-md-2 col-12 border rounded p-1" nav-class="nav-left">
            <b-tab  :title="$t('Basic Information')" active>
              <info-tab></info-tab>
            </b-tab>

            <b-tab v-if="$store.state.auth.userData.roles.includes('Super Admin')"
                   :title="$t('camera setup')" lazy>
            <camera-setup-tab></camera-setup-tab>
            </b-tab>

            <b-tab :title="$t('attributes')" lazy>
              <device-attribute-tab></device-attribute-tab>
            </b-tab>
            <b-tab :title="$t('scale sensor settings')" lazy>
              <sensors-tab></sensors-tab>
            </b-tab>
            <b-tab 
              :title="$t('SIM')"
              v-if="$store.state.auth.userData.roles.includes(roles.SUPER_ADMIN)"
            >
              <sim-tab></sim-tab>
            </b-tab>
            <!-- <b-tab v-if="$store.state.auth.userData.roles.includes($roles.SUPER_ADMIN)" :title="$t('Wasl Information')" lazy>
              <wasl-tab :device-data="deviceData"></wasl-tab>
            </b-tab> -->
          </b-tabs>
        </b-col>

        <!-- reset and submit -->
        <b-col cols="12" class="mt-2">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
          >
            {{ $t('Save') }}
          </b-button>
          <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              variant="outline-secondary">
            {{ $t('Reset') }}
          </b-button>
        </b-col>

      </b-row>


    </b-form>
  </b-card>
</template>

<script>

import { OrbitSpinner } from 'epic-spinners'
import { heightTransition } from '@core/mixins/ui/transition'
import {
  BButton,
  BCard, BCol,
  BForm, BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { computed, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import { DeviceStore } from '@/app/devices/state'
import DeviceAttributeTab from '@/views/modules/device/tabs/DeviceAttributeTab'
import CameraSetupTab from '@/views/modules/device/tabs/CameraSetupTab.vue'
import InfoTab from '@/views/modules/device/tabs/InfoTab'
import SensorsTab from '@/views/modules/device/tabs/SensorsTab'
import SimTab from '@/views/modules/device/tabs/SimTab'
import WaslTab from '@/views/modules/device/tabs/WaslTab'

import roles from "@/const/roles";


export default {
  name: 'CreateDevice',
  components: {
    BRow, InfoTab, SensorsTab, WaslTab, DeviceAttributeTab, SimTab, CameraSetupTab,
    BCard,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner
  },
  directives: {
    Ripple,
  },

  setup(props, { root }) {

    const auth = store.state.auth.userData

    const DEVICE_STORE = 'device'

    if(!store.hasModule(DEVICE_STORE)){
        store.registerModule('device', DeviceStore)
    }

    onUnmounted(() => {
      if (store.hasModule(DEVICE_STORE))
          store.unregisterModule(DEVICE_STORE)
    })

    store.dispatch('device/fetchLists', auth.id)

    const deviceData = computed(() => store.state.device.data)
    const loading = computed(() => store.state.device.loading)

    const createDevice = () => {
      store.dispatch('device/createDevice').then(res => {
        root.$bvToast.toast(
            root.$i18n.t("device created successfully"), {
              title: `Success`,
              variant: 'success',
            })
      }).catch(reason => {
        console.log(reason)
      })
    }


    return {
      deviceData,
      loading,
      createDevice,
      roles
    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
// .vs__dropdown-menu {
  
//    z-index: 9999;
//    min-height: 400px;
//    overflow:scroll;
//    }
.repeater-form {
  overflow: show;
  transition: .35s height;
}

</style>
